import React, { Component } from "react";

import {
  Banner
} from "@shopify/polaris";

import {
  withRouter
} from 'react-router-dom';

import { reqCountJumpService } from "../../api";

//翻译包
import Language from '../../i18n/Language';
const t = Language

class CountJumpServiceBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clickstatus: true,
    }
  }

  //服务内部引流跳转
  CountJumpService = async (form) => {
    this.setState({
      clickstatus: false
    })

    if (this.state.clickstatus) {
      const params = {
        form: form
      }
      const response = await reqCountJumpService(params);
      if (response.code === "200") {
        // if (form === 1 || form === 3) {
        //   utils.routeJump(this, "/admin/seo-expert-services/3")
        // }
        // if (form === 2 || form === 4 || form === 5) {
        //   utils.routeJump(this, "/admin/seo-expert-services/10")
        // }
        // window.$crisp.push(["do", "chat:open"])
        // if(form === 3) {
        //   window.$crisp.push(["set", "message:text", ['I need help with Google Search Console']])
        // } else {
        //   window.$crisp.push(["set", "message:text", ['I need help to fix seo checker issues']])
        // }
      }
      let info = 'I need help to fix seo checker issues'
      if(form === 3) {
        info = 'I need help with Google Search Console'
      } 
      try {
        window.Willdesk.chat(info)
      } catch(e) {
        // this.toggleToast(t("Try again later"), true);
      }
        
    }
  }

  render() {
    /**
     * 1.Seo Checker页面
     * 2.On-Page SEO Scan页面
     * 3.Google Search Console 页面
     * 4.Competitor keywords页面
     * 5.Keywords library页面
     */
    var bannerText = "", bannerTitle = "";
    if (this.props.form === 1) {
      bannerTitle = <p>{t("Have any issues ?")}</p>;
      bannerText = <div><p><span style={{ color: "#005BD3", textDecoration: "underline", cursor: "pointer" }} onClick={() => { this.CountJumpService(1); }}>{t("Contact Us")}</span> {t("to fix it and save your time.")}</p></div>
    }
    if (this.props.form === 2) {
      bannerTitle = <p>{t("Do not know how to do on-page optimization?")}</p>;
      bannerText = <div><p><span style={{ color: "#005BD3", textDecoration: "underline", cursor: "pointer" }} onClick={() => { this.CountJumpService(2); }}>{t("Contact Us")}</span> {t("to save your time and bring you more organic traffic.")}</p></div>
    }
    if (this.props.form === 3) {
      bannerTitle = <p>{t("Have any issues with Google Search Console?")}</p>;
      bannerText = <div><p><span style={{ color: "#005BD3", textDecoration: "underline", cursor: "pointer" }} onClick={() => { this.CountJumpService(3); }}>{t("Contact Us")}</span> {t("to fix it and save your time.")}</p></div>
    }
    if(this.props.form === 4){
      bannerTitle = <p>{t("Is researching keywords too difficult? Hire an expert to save your time.")}</p>;
      bannerText = <div><p><span style={{ color: "#005BD3", textDecoration: "underline", cursor: "pointer" }} onClick={() => { this.CountJumpService(4); }}> {t("Click to view service details.")}</span></p></div>
    }
    if(this.props.form === 5){
      bannerTitle = <p>{t("Is researching keywords too difficult? Hire an expert to save your time.")}</p>;
      bannerText = <div><p><span style={{ color: "#005BD3", textDecoration: "underline", cursor: "pointer" }} onClick={() => { this.CountJumpService(5); }}> {t("Click to view service details.")}</span></p></div>
    }

    const banner = <Banner tone="info"
      title={bannerTitle}
      onDismiss={() => this.props.closeBannerObj(this.props.form)}
    >
      {bannerText}
    </Banner>

    return (
      banner 
    );
  }
}

export default withRouter(CountJumpServiceBanner);